<template>
	<!-- Header(leftside) -->
	<header class="iv2-global">
		<div class="iv2-global__items">
			<h1 v-if="general.logos" class="iv2-global__logo">
				<router-link @click="activeMenu = false" to="/" class="iv2-global__link">
					<img :src="general.logos.basic_type1" class="iv2-global__logo-img" :alt="general.profile.name" />
				</router-link>
			</h1>
			<div class="iv2-global__menu d-xl-none text-center m-auto">
				<!-- Header Sub Menu -->
				<nav class="iv2-global__sub-menu d-none d-md-inline-block d-xl-none mr-3 h-100 align-middle">
					<div
						v-for="subnav in extra_menu"
						:key="subnav.id"
						class="iv2-global__sub-menu-item text-center d-inline-block align-top"
					>
						<div v-if="subnav.link_type == 'internal'">
							<router-link
								:to="subnav.url"
								class="iv2-global__sub-menu-link theme-c__global-sns-link text-black"
							>
								<i :class="'iv2-global__sub-menu-item-icon d-block ' + subnav.icon"></i>
								<span class="iv2-global__sub-menu-item-text d-block">{{ subnav.name }}</span>
							</router-link>
						</div>
						<div v-else-if="subnav.link_type == 'external'">
							<a
								v-bind:href="subnav.url"
								:target="subnav.target_type"
								rel="noopener"
								class="iv2-global__sub-menu-link theme-c__global-sns-link text-black"
							>
								<i :class="'iv2-global__sub-menu-item-icon d-block ' + subnav.icon"></i>
								<span class="iv2-global__sub-menu-item-text d-block">{{ subnav.name }}</span>
							</a>
						</div>
						<div v-else-if="subnav.link_type == 'push'" class="iv2-global-push-button">
							<button
								class="iv2-global__sub-menu-link theme-c__global-sns-link text-black align-top"
								style="background-color: transparent; border: none; padding: 0;"
							>
								<i
									id="iv2-global__sub-menu-item-icon"
									:class="'iv2-global__sub-menu-item-icon d-block ' + subnav.icon"
								></i>
								<span class="iv2-global__sub-menu-item-text d-block">{{ subnav.name }}</span>
							</button>
						</div>
					</div>
				</nav>

				<div class="iv2-global__btn d-inline-block align-middle">
					<div
						@click="activeMenu = !activeMenu"
						:class="{ active: activeMenu }"
						class="iv2-global__btn-icon position-relative bg-transparent border border-0 p-0"
					>
						<span class="iv2-global__top-drawer theme-c__global-icon iv2-global__humbergar"></span>
						<span class="iv2-global__center-drawer theme-c__global-icon"></span>
						<span class="iv2-global__bottom-drawer theme-c__global-icon"></span>
					</div>
					<span
						class="iv2-global__menu-text theme-c__global-text d-block"
						v-if="activeMenu == false"
					>MENU</span>
					<span
						class="iv2-global__menu-text theme-c__global-text d-block"
						v-else-if="activeMenu == true"
					>CLOSE</span>
				</div>
			</div>
		</div>

		<nav :class="[{ active: activeMenu } , navColorClass]" n class="iv2-nav theme-c__nav-text">
			<!-- Navigation Sub Menu -->
			<div class="iv2-nav__block">
				<ul v-if="sns.facebook" class="iv2-nav__list list-unstyled mt-xl-3">
					<li
						v-for="nav in global_menu.slice(0, 16)"
						:key="nav.id"
						class="iv2-nav__item theme-c__nav-item"
						:class="{selected: activeNav===nav && !nav.children.length == false }"
						@mouseover="activeNav=nav"
						@mouseleave="activeNav=''"
					>
						<router-link
							v-if="nav.link_type == 'internal' && !nav.children.length == true"
							:to="nav.url"
							class="iv2-nav__link theme-c__nav-link"
						>{{ nav.name }}</router-link>
						<a
							v-else-if="nav.link_type == 'external' && !nav.children.length == true"
							:href="nav.url"
							@click="activeMenu = false"
							:target="nav.target_type"
							rel="noopener"
							class="iv2-nav__link theme-c__nav-link"
						>{{ nav.name }}</a>
						<router-link
							v-if="nav.link_type == 'internal' && !nav.children.length == false"
							:to="nav.url"
							class="iv2-nav__link theme-c__nav-link"
						>{{ nav.name }}</router-link>
						<a
							v-else-if="nav.link_type == 'external' && !nav.children.length == false"
							:href="nav.url"
							@click="activeMenu = false"
							:target="nav.target_type"
							rel="noopener"
							class="iv2-nav__link theme-c__nav-link"
						>{{ nav.name }}</a>
						<a
							v-if="!nav.children.length == false"
							@click="activeList"
							class="iv2-nav__acordion theme-c__nav-acordion d-inline-block d-xl-none position-relative"
							href="javascript:void(0)"
						></a>
						<ul
							v-if="!nav.children.length == false"
							:class="navChildColor"
							class="iv2-nav__list list-unstyled"
						>
							<li
								v-for="cNav in nav.children"
								:key="cNav.id"
								class="iv2-nav__item theme-c__nav-item--inner"
							>
								<router-link
									v-if="cNav.link_type == 'internal'"
									:to="cNav.url"
									class="iv2-nav__link theme-c__nav-link--inner"
								>{{ cNav.name }}</router-link>
								<a
									v-else-if="cNav.link_type == 'external'"
									:href="cNav.url"
									@click="activeMenu = false"
									:target="cNav.target_type"
									rel="noopener"
									class="iv2-nav__link theme-c__nav-link--inner"
								>{{ cNav.name }}</a>
							</li>
						</ul>
					</li>
				</ul>

				<div class="iv2-nav__footer container-fluid">
					<div class="row m-0" style="width: 100%;">
						<div v-if="general.profile" class="iv2-nav__footer-item col-12">
							<div class="iv2-nav__footer-tel d-inline-flex">
								<i class="fas fa-phone-alt mt-3 mr-2"></i>
								<p class="iv2-nav__footer-tel--text mb-1" style="line-height: 1;">{{ general.profile.tel }}</p>
							</div>

							<div class="iv2-nav__footer-time">
								<p
									v-html="general.profile.business_hours"
									class="size-12 mt-xl-2"
									style="line-height: 1.3;"
								></p>
							</div>
							<div class="iv2-nav__footer-adress p-0">
								<p class="size-12" style="line-height: 1.3;">
									{{ "〒" + general.profile.zipcode }}&emsp;
									{{
									general.profile.address_pref +
									general.profile.address_city +
									general.profile.address_town +
									general.profile.address_build
									}}
								</p>
							</div>
						</div>
						<div class="col-12 d-block d-xl-none text-center">
							<!-- SP SNS -->
							<div class="iv2-nav__mobile-sns m-auto">
								<ul
									v-if="sns.facebook && sns.instagram && sns.twitter && sns.line && rss.outbound"
									class="iv2-nav__mobile-sns-list mb-0 list-unstyled"
								>
									<li v-if="sns.facebook.status == 1" class="iv2-nav__mobile-sns-item">
										<a
											:href="sns.facebook.url"
											class="iv2-nav__mobile-sns-link theme-c__nav-sns-link"
											target="_blank"
											rel="noopener"
										>
											<i class="fab fa-facebook-f"></i>
										</a>
									</li>
									<li v-if="sns.instagram.status == 1" class="iv2-nav__mobile-sns-item">
										<a
											:href="sns.instagram.url"
											class="iv2-nav__mobile-sns-link theme-c__nav-sns-link"
											target="_blank"
											rel="noopener"
										>
											<i class="fab fa-instagram"></i>
										</a>
									</li>
									<li v-if="sns.twitter.status == 1" class="iv2-nav__mobile-sns-item">
										<a
											:href="sns.twitter.url"
											class="iv2-nav__mobile-sns-link theme-c__nav-sns-link"
											target="_blank"
											rel="noopener"
										>
											<i class="fab fa-twitter"></i>
										</a>
									</li>
									<li v-if="sns.line.status == 1" class="iv2-nav__mobile-sns-item">
										<a
											:href="sns.line.url"
											class="iv2-nav__mobile-sns-link theme-c__nav-sns-link"
											target="_blank"
											rel="noopener"
										>
											<i class="fab fa-line"></i>
										</a>
									</li>
									<li v-if="rss.outbound.status == 1" class="iv2-nav__mobile-sns-item">
										<a
											:href="rss.outbound.href"
											class="iv2-nav__mobile-sns-link theme-c__nav-sns-link"
											target="_blank"
											rel="noopener"
										>
											<i class="fas fa-rss"></i>
										</a>
									</li>
								</ul>
							</div>
							<div class="iv2-nav__copyright mt-3">
								<small>{{ general.copyright }}</small>
							</div>
						</div>
					</div>
				</div>
			</div>
		</nav>
	</header>
</template>

<script>
export default {
	data() {
		return {
			general: [],
			global_menu: [],
			extra_menu: [],
			sns: [],
			rss: [],

			activeMenu: true,
			activeNav: "",
			navColorClass: "",
			navChildColor: ""
		};
	},

	created() {
		this.axios.get("/json/settings.json").then(response => {
			this.general = response.data.settings.general;
			this.sns = response.data.settings.sns;
		});

		this.axios.get("/json/navigations.json").then(response => {
			this.global_menu = response.data.navs.global_menu;
			this.extra_menu = response.data.navs.extra_menu;
		});

		this.axios.get("/json/rss.json").then(response => {
			this.rss = response.data.rss;
		});

		window.addEventListener("resize", this.handleResize);
		this.handleResize();
	},

	mounted() {
		this.handleResize();
		{
			if (window.innerWidth <= 1200) {
				this.activeMenu = false;
			} else {
				this.activeMenu = true;
			}
		}
	},

	destroyed() {
		window.removeEventListener("resize", this.handleResize);
	},

	methods: {
		activeList: function(e) {
			e.currentTarget.parentNode.classList.toggle("active");
		},

		handleResize: function() {
			// if (window.innerWidth >= 1200) {
			// 	this.activeMenu = true;
			// }

			if (window.innerWidth >= 1199) {
				this.navColorClass = "theme-c__global-bg";
			} else {
				this.navColorClass = "theme-c__nav-bg";
			}

			if (window.innerWidth >= 1199) {
				this.navChildColor = "theme-c__nav-bg";
			} else {
				this.navChildColor = "";
			}
		}
	},

	watch: {
		$route: function(to, from) {
			if (to.path !== from.path && window.innerWidth <= 1199) {
				this.activeMenu = false;
			}
		}
	}
};
</script>

<style lang="scss">
.iv2-global {
	z-index: 5;

	.iv2-global__items {
		position: relative;
		.iv2-global__logo {
			margin: auto;
			background-color: #fff;
			padding: 5px 10px;
		}

		.iv2-global__menu {
			top: 50%;
			left: 0;
			right: 0;

			.iv2-global__btn {
				.iv2-global__btn-icon {
					width: 30px;
					height: 20px;
					margin: 0 auto;
					cursor: pointer;

					.iv2-global__top-drawer,
					.iv2-global__center-drawer,
					.iv2-global__bottom-drawer {
						display: block;
						position: absolute;
						width: 100%;
						height: 2px;
						margin: auto;
						right: 0;
						left: 0;
						transition: 0.3s;
					}

					.iv2-global__top-drawer {
						top: 2px;
					}

					.iv2-global__center-drawer {
						top: 0;
						bottom: 0;
						visibility: visible;
						opacity: 1;
					}

					.iv2-global__bottom-drawer {
						bottom: 2px;
					}

					&.active {
						.iv2-global__top-drawer {
							top: 0;
							bottom: 0;
							transform: rotate(-45deg);
						}

						.iv2-global__center-drawer {
							visibility: hidden;
							opacity: 0;
						}

						.iv2-global__bottom-drawer {
							top: 0;
							bottom: 0;
							transform: rotate(45deg);
						}
					}

					&:focus {
						outline: 0;
					}
				}
			}

			.iv2-global__menu-text {
				font-size: 10px;
				font-weight: 400;
				line-height: 1;
			}
		}
	}

	.iv2-nav {
		width: 100%;
		z-index: 5;
		visibility: hidden;
		display: none;

		&.active {
			visibility: visible;
			display: block;
		}

		.iv2-nav__block {
			> .iv2-nav__list {
				display: inline-block;
				vertical-align: top;

				.iv2-nav__item {
					font-size: 16px;
					letter-spacing: 2px;
					font-family: Playfair Display, serif;
					font-weight: bold;

					.iv2-nav__link {
						&:hover {
							text-decoration: none;
						}
					}

					> .iv2-nav__list {
						padding-left: 20px;
						padding-left: 0;

						.iv2-nav__item {
							font-size: 16px;

							// .iv2-nav__link {
							// 	&::before {
							// 		content: "";
							// 		display: inline-block;
							// 		margin-right: 10px;
							// 		width: 10px;
							// 		vertical-align: middle;
							// 	}
							// }
						}
					}
				}
			}
		}

		.iv2-nav__footer {
			padding: 1.5rem 1.5rem 0;
			margin-left: 0;
			margin-right: 0;
			z-index: 1;

			.iv2-nav__footer-tel {
				width: 100%;
			}

			.iv2-nav__footer-adress {
				text-align: left;
			}
		}
	}
}

/* PC */
@media (min-width: 1200px) {
	@keyframes tooltipShow {
		from {
			opacity: 0;
			transform: translateX(-20px);
		}

		to {
			opacity: 1;
		}
	}
	@keyframes fade-move {
		0% {
			transform-origin: 0% 0;
			transform: translate3d(0%, 0%, 0px) scale(0, 1);
		}
		100% {
			transform-origin: 0% 0;
			transform: translate3d(0%, 0%, 0px) scale(1, 1);
		}
	}
	.iv2-global {
		text-align: center;
		.iv2-global__items {
			padding-top: 5px;
			position: fixed;
			z-index: 7;
			.iv2-global__logo {
				width: 250px;
				height: 210px;
				padding: 0 45px;
				display: table-cell;
				vertical-align: middle;
			}
			.iv2-global__menu {
				position: absolute;
			}
		}

		.iv2-nav {
			padding-top: 210px;
			.iv2-nav__block {
				> .iv2-nav__list {
					width: 100%;
					.iv2-nav__item {
						font-size: 15px;
						line-height: 2.6;

						> .iv2-nav__list {
							padding-top: 210px;
							width: 0px;
							height: 100vh;
							position: fixed;
							top: 0;
							left: 250px;
							visibility: hidden;
							transition: 0.5s;
							opacity: 0;
							z-index: 0;

							.iv2-nav__item {
								font-size: 14px;
							}
						}

						&.selected {
							> .iv2-nav__list {
								visibility: visible;
								opacity: 1;
								width: 250px;
							}

							> .iv2-nav__link {
								display: block;
								position: relative;
								&::after {
									content: "";
									width: 42px;
									height: 1px;
									border-top: 1px solid;
									display: block;
									position: absolute;
									right: 0;
									top: 50%;
									animation: fade-move 0.3s
										cubic-bezier(0, 0.3, 0.25, 1);
								}
							}
						}
					}
				}
			}

			.iv2-nav__footer {
				// position: absolute;
				// bottom: 10%;
				.iv2-nav__footer-item {
					padding: 0px 17px;

					.iv2-nav__footer-tel {
						width: 100%;
						border-top: 1px solid;
						font-size: 18px;

						.iv2-nav__footer-tel--text {
							font-size: 18px;
						}
					}

					.iv2-nav__footer-time {
						border-bottom: 1px solid;
					}

					.iv2-nav__footer-adress {
						text-align: left;
					}
				}
			}
		}
	}
}

/* TABLET or SP */
@media (max-width: 1199px) {
	@keyframes tooltipShow {
		from {
			opacity: 0;
			transform: translateY(50px);
		}

		to {
			opacity: 1;
		}
	}
	.iv2-global {
		.iv2-global__items {
			.iv2-global__logo {
				display: inline-block;
				height: 100%;
				margin-bottom: auto;
				margin-left: 5px;

				.iv2-global__link {
					margin-bottom: 0;
					height: 100%;
					display: inline-block;

					.iv2-global__logo-img {
						vertical-align: top;
						height: 100%;
					}
				}
			}
			.iv2-global__menu {
				height: 100%;
				float: right;
				padding: 10px;

				.iv2-global__btn {
					line-height: 1;
				}

				.iv2-global__menu-text {
					margin-top: 6px;
				}
			}
		}
		.iv2-nav {
			position: absolute;
			top: 0;
			left: 0;
			margin-top: 64px;
			height: 100vh;
			overflow-y: auto;
			overflow-x: hidden;
			animation: tooltipShow 0.5s linear 0s;

			.iv2-nav__sub-menu-item {
				font-size: 1.75em;
				border-right: 1px solid;

				&:last-child {
					border-right: none;
				}
			}
			.iv2-nav__sub-menu-item-text {
				font-size: 0.5em;
				line-height: 1.3;
			}
			.iv2-nav__block {
				padding: 30px 20px 20px;

				.iv2-nav__list {
					display: block;
					margin: auto;
					padding: 0 64px;
					float: none;

					.iv2-nav__item {
						position: relative;
						display: block;
						font-size: 1em;
						margin: 0;

						.iv2-nav__link {
							display: block;
							padding: 15px 0;
						}

						.iv2-nav__link-parent {
							width: 80%;
							border-right: 1px solid;
						}

						> .iv2-nav__list {
							padding: 0;
							visibility: hidden;
							opacity: 0;
							height: 0;

							&.active {
								visibility: visible;
								opacity: 1;
								height: auto;
								transition: 0.5s;
							}
						}

						.iv2-nav__acordion {
							width: 61px;
							height: 45px;
							float: right;
							transform: translateY(-100%);
							bottom: 8px;
							&::before {
								content: "";
								width: 0;
								height: 0;
								position: absolute;
								top: 50%;
								right: 50%;
								transform: translate(50%, -50%);
								transition: 0.2s;
							}
						}

						&.active {
							> .iv2-nav__list {
								visibility: visible;
								opacity: 1;
								height: auto;
								> .iv2-nav__item {
									font-size: 1em;
								}
							}

							.iv2-nav__acordion {
								&::before {
									transform: translate(50%, -50%)
										rotate(90deg);
								}
							}
						}
					}
				}
			}

			.iv2-nav__footer {
				padding: 1.5rem 3rem 6rem;
				.iv2-nav__footer-tel {
					border-bottom: 0.5px solid;
					font-size: 14px;
					padding-bottom: 5px;

					.iv2-nav__footer-tel--text {
						font-size: 14px;
					}
				}

				.iv2-nav__footer-time {
					border-bottom: 0.5px solid;
				}
			}

			.iv2-nav__mobile-sns-list {
				border-top: double 4px;
				border-bottom: double 4px;
				.iv2-nav__mobile-sns-item {
					font-size: 1.3em;
					display: inline-block;
					margin-right: 20px;

					&:last-child {
						margin-right: 0;
					}
				}
			}
		}
	}
}

/* TABLET Only */
@media (min-width: 768px) and (max-width: 1199px) {
	.iv2-global {
		.iv2-global__items {
			.iv2-global__menu {
				.iv2-global__btn {
					margin-right: 0.5rem;
				}

				.iv2-global__sub-menu {
					.iv2-global__sub-menu-item {
						font-size: 1.5rem;
						width: 80px;

						.iv2-global__sub-menu-link {
							&:hover {
								text-decoration: none;
							}
						}

						.iv2-global__sub-menu-item-text {
							font-size: 10px;
							font-weight: 400;
							margin-top: 6px;
							line-height: 1.3;
						}
					}
				}
			}
		}
	}
}

/* SP Only */
@media (max-width: 767px) {
	.iv2-global {
		.iv2-global__items {
			.iv2-global__menu {
				padding: 5px 10px;
				.iv2-global__menu-text {
					margin-top: 0;
				}
				.iv2-global__btn {
					.iv2-global__btn-icon {
						width: 20px;
						margin-left: 6px;

						&.active {
							margin-left: 7px;
						}
					}
				}
			}
		}

		.iv2-nav {
			margin-top: 45px;
			padding-bottom: calc(env(safe-area-inset-bottom));
			.iv2-nav__block {
				.iv2-nav__list {
					padding: 0 21px;
					.iv2-nav__item {
						.iv2-nav__link {
							padding: 15px 5px;
						}
					}
				}
			}
			.iv2-nav__footer {
				padding: 1.5rem 0.4rem 6rem;
				margin-bottom: 60px;
			}
		}
	}
}
</style>
